import {Ng2StateDeclaration} from "@uirouter/angular";
import {WorkPackagesBaseComponent} from 'core-app/features/work-packages/routing/wp-base/wp--base.component';
import {WorkPackageViewPageIframeComponent} from "./components/wp-view-page-iframe.component";
import {WorkPackageListViewIframeComponent} from "./components/wp-list-view-iframe.component";

export const OPENPROJECT_METEOR_CORE_ROUTES: Ng2StateDeclaration[] = [
  {
    name: 'work-packages-iframe',
    parent: 'optional_project',
    url: '/work_packages_iframe?query_id&query_props',
    redirectTo: 'work-packages-iframe.partitioned.list',
    views: {
      '!$default': {component: WorkPackagesBaseComponent},
    },
    data: {
      bodyClasses: ['router--work-packages-base', 'zen-mode'],
    },
    params: {
      query_id: {type: 'query', dynamic: true},
      // Use custom encoder/decoder that ensures validity of URL string
      query_props: {type: 'opQueryString'},
    },
  },
  {
    name: 'work-packages-iframe.partitioned',
    component: WorkPackageViewPageIframeComponent,
    url: '',
    data: {
      // This has to be empty to avoid inheriting the parent bodyClasses
      bodyClasses: '',
    },
  },
  {
    name: 'work-packages-iframe.partitioned.list',
    url: '',
    reloadOnSearch: false,
    views: {
      'content-left': {component: WorkPackageListViewIframeComponent},
    },
    data: {
      bodyClasses: 'router--work-packages-partitioned-split-view',
      partition: '-left-only',
    }
  }
];